import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardHeader, Badge } from 'reactstrap';
import { APIClient } from '../../helpers/api_helper';

interface Activity {
    id: number;
    type: string;
    user: string;
    description: string;
    timestamp: string;
    status: string;
}

const RecentActivities = () => {
    const [activities, setActivities] = useState<Activity[]>([]);
    const [loading, setLoading] = useState(true);
    const apiClient = new APIClient();

    useEffect(() => {
        fetchRecentActivities();
    }, []);

    const fetchRecentActivities = async () => {
        try {
            setLoading(true);
            const response: any = await apiClient.get('/dashboard/recent-activities?limit=10');

            if (response.code === 200 && response.data) {
                setActivities(response.data);
            }
        } catch (error) {
            console.error('Error fetching recent activities:', error);
        } finally {
            setLoading(false);
        }
    };

    const getStatusBadge = (status: string) => {
        switch (status) {
            case 'success':
                return <Badge color="success">Success</Badge>;
            case 'pending':
                return <Badge color="warning">Pending</Badge>;
            case 'failed':
                return <Badge color="danger">Failed</Badge>;
            default:
                return <Badge color="secondary">{status}</Badge>;
        }
    };

    return (
        <Card>
            <CardHeader>
                <h5 className="card-title mb-0">Recent Activities</h5>
            </CardHeader>
            <CardBody>
                {loading ? (
                    <div className="text-center">Loading...</div>
                ) : activities.length === 0 ? (
                    <div className="text-center text-muted">No recent activities</div>
                ) : (
                    <div className="table-responsive">
                        <table className="table table-borderless table-nowrap align-middle mb-0">
                            <tbody>
                                {activities.map((activity) => (
                                    <tr key={activity.id}>
                                        <td>
                                            <div className="d-flex">
                                                <div className="flex-grow-1">
                                                    <h6 className="mb-1">{activity.description}</h6>
                                                    <p className="text-muted mb-0">{activity.user} • {activity.timestamp}</p>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="text-end">
                                            {getStatusBadge(activity.status)}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </CardBody>
        </Card>
    );
};

export default RecentActivities;
